import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';
import { ContextProviderNode } from '@decisions/server/DecisionsFramework/Design/Properties';
import { MappingTypeSelector } from './MappingTypeSelector';

interface IComputeDateMappingProps {
  node: ContextProviderNode;
  path: string[];
}

/**
 * Nested mapping selectors ComputeData mapping, which is a compound mapping.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ComputeDateMapping({ node, path }: IComputeDateMappingProps) {
  // nodes 0 and 1 are the top-level mapping, while 2 & 3 are the nested mappings:
  const fromNode = node.Children[2];
  const fromPath = [...path, fromNode.Node.Name];
  const toNode = node.Children[3];
  const toPath = [...path, toNode.Node.Name];
  return (
    <section className="dpc-mapping-selector__nested-mapping">
      <MappingTypeSelector
        child={fromNode as IPropertyChild}
        path={fromPath}
        key={fromPath.join(',')}
       />
      <MappingTypeSelector child={toNode as IPropertyChild} path={toPath} key={toPath.join(',')} />
    </section>
  );
}
